import { ContentFragment, Data as ArticleData } from '@root/modules/article/types/article';
import articleConfig from '@root/modules/article/config/article.config';
import { Config } from '@root/modules/channel/types/channel';
import striptags from 'striptags';
import cloneDeep from 'lodash/cloneDeep';

type Fragment = ContentFragment;

interface FragmentsGroup {
  items: (Fragment | string)[];
  options: {
    title: string | null;
    skipAds: boolean;
    addRelatedHeadlines: boolean;
    relatedPosition: number;
  };
}

const initFragmentsGroup: FragmentsGroup = {
  items: [],
  options: {
    title: null,
    skipAds: false,
    addRelatedHeadlines: false,
    relatedPosition: 1,
  },
};

const getArticleMultipageBody = (article: ArticleData, settings: Config['page']['article']['component']): FragmentsGroup[] => {
  const { relatedArticles } = settings;
  const relatedArticlesSettings = relatedArticles;

  const body = article.content.body.content;
  const fragmentsSize = body.length;

  if (!body || fragmentsSize === 0) {
    return [];
  }

  const adsFrequency = articleConfig.ads.frequencyMultipage;
  const group: FragmentsGroup[] = [];

  let charCounter = 0;
  let adInjected = false;
  let addRelatedHeadlines = true;
  let fragments: (Fragment | string)[] = [];
  let nextGroupFragment: Fragment | null = null;
  let fragmentsGroup = cloneDeep(initFragmentsGroup);

  for (let i = 0; i < fragmentsSize; i++) {
    const isLast = i === fragmentsSize - 1;
    const fragment = body[i];
    const text = striptags(fragment.html);
    let closeSubGroup = false;
    let pageBreakTitle = null;

    // Set closeSubGroup is last pushed fragment attrs has page_break
    if (fragment.attrs && fragment.attrs.page_break && fragment.attrs.page_break === true) {
      closeSubGroup = true;
      pageBreakTitle = striptags(fragment.html);
      nextGroupFragment = fragment;
    } else {
      fragments.push(fragment);
    }

    if (adsFrequency <= charCounter && !adInjected) {
      adInjected = true;
      fragments.push('adFragment');
    }

    charCounter += text.length;

    // close the group if closeSubGroup is set, or fragment is last element
    if (closeSubGroup || isLast) {
      fragmentsGroup.items = [...fragmentsGroup.items, ...fragments];
      fragmentsGroup.options.title = pageBreakTitle;
      fragmentsGroup.options.addRelatedHeadlines = fragments.length > relatedArticlesSettings.minParagraphsLength && addRelatedHeadlines;

      // Calculate related headlines position in fragments group
      if (fragmentsGroup.options.addRelatedHeadlines) {
        fragmentsGroup.options.relatedPosition = relatedArticlesSettings.afterParagraphPosition;
      }

      group.push(fragmentsGroup);

      fragmentsGroup = cloneDeep(initFragmentsGroup);

      // Push nextGroupFragment to group if defined;
      if (nextGroupFragment !== null) {
        fragmentsGroup.items.push(nextGroupFragment);
        nextGroupFragment = null;
      }

      pageBreakTitle = null;
      addRelatedHeadlines = false;
      adInjected = false;
      charCounter = 0;
      fragments = [];
      closeSubGroup = false;
    }
  }

  return group;
};

export default getArticleMultipageBody;
